import {InfiniteData, useMutation, useQueryClient} from '@tanstack/react-query'
import {unlockMediaPackage} from '../services/mediaPackages.http'
import {MUTATION_KEYS} from './keys'
import {HostFeedResponseGeneralV3, MediaPackageFeedV3} from '@/features/feed/types'
import {QUERY_KEYS as FEED_QUERY_KEYS} from '@/features/feed/queries/keys'
import {QUERY_KEYS as PROFILE_QUERY_KEYS} from '@/features/profile/queries/keys'
import {getReactQueryKey} from '@/utilities/helpers'

export const useUnlockMediaPackage = (onSuccess?: (data: MediaPackageFeedV3) => void) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [MUTATION_KEYS.unlockMedialPackage],
        mutationFn: unlockMediaPackage,
        onSuccess: data => {
            const feedV3Key = getReactQueryKey(FEED_QUERY_KEYS.feedV3)
            const muralV2Key = getReactQueryKey(PROFILE_QUERY_KEYS.mural_of_host)

            queryClient.setQueriesData<InfiniteData<HostFeedResponseGeneralV3>>({queryKey: feedV3Key}, oldData => {
                if (!oldData) return oldData
                const newData = oldData.pages.map(page => ({
                    ...page,
                    data: page.data.map(item => (item.id === data.id ? {...item, ...data} : item))
                }))
                return {...oldData, pages: newData}
            })

            //TODO: change it after adding HostMuralV3 to profile
            queryClient.invalidateQueries({queryKey: muralV2Key})
            onSuccess?.(data)
        }
    })
}
